export const PUBLISH_POST_BUTTON = 'new-post-publish-btn';
